const cartInitialState = {
  cart: {kitItems:[], arKitItems:[], additionalProducts:[], arAdditionalProducts:[]}
};
export default cartInitialState;



// WEBPACK FOOTER //
// ./src/store/initialStates/cartInitialState.js